import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/modules/retailer/Dashboard';
import UPITransfer from '../pages/modules/retailer/UPITransfer';
import UPICollect from '../pages/modules/retailer/UPICollect';
import FundTransfer from '../pages/modules/retailer/FundTransfer';
import AEPS from '../pages/modules/retailer/AEPS';
import MicroATMPOS from '../pages/modules/retailer/MicroATMPOS';
import MobileRecharge from '../pages/modules/retailer/MobileRecharge';
import BillPaymentServices from '../pages/modules/retailer/BillPaymentServices';
import BillPaymentPayment from '../pages/modules/retailer/BillPaymentPayment';
import DTHRecharge from '../pages/modules/retailer/DTHRecharge';
import BalanceRequest from '../pages/modules/retailer/BalanceRequest';
import ClaimRefund from '../pages/modules/retailer/ClaimRefund';
import PayoutBeneficiary from '../pages/modules/retailer/PayoutBeneficiary';
import NetworkPayment from '../pages/modules/retailer/NetworkPayment';
import CommissionReports from '../pages/modules/retailer/CommissionReports';
import LedgerReports from '../pages/modules/retailer/LedgerReports';
import BalReqHistory from '../pages/modules/retailer/BalReqHistory';
import OutstandingReports from '../pages/modules/retailer/OutstandingReports';
import PayoutReports from '../pages/modules/retailer/PayoutReports';
import MyProfile from '../pages/profile/MyProfile';

const RetailerRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/upi-transfer" element={<UPITransfer />} />
      <Route path="/upi-collect" element={<UPICollect />} />
      <Route path="/fund-transfer" element={<FundTransfer />} />
      <Route path="/aeps" element={<AEPS />} />
      <Route path="/micro-atm-pos" element={<MicroATMPOS />} />
      <Route path="/mobile-recharge" element={<MobileRecharge />} />
      <Route path="/dth-recharge" element={<DTHRecharge />} />
      <Route path="/bill-payments" element={<BillPaymentServices />} />
      <Route path="/bill-payments/payment" element={<BillPaymentPayment />} />
      <Route path="/my-account/balance-request" element={<BalanceRequest />} />
      <Route path="/my-account/claim-refund" element={<ClaimRefund />} />
      <Route path="/my-account/payout-beneficiary" element={<PayoutBeneficiary />} />
      <Route path="/my-account/network-payment" element={<NetworkPayment />} />
      <Route path="/reports/commission-reports" element={<CommissionReports />} />
      <Route path="/reports/ledger-reports" element={<LedgerReports />} />
      <Route path="/reports/bal-req-history" element={<BalReqHistory />} />
      <Route path="/reports/outstanding-reports" element={<OutstandingReports />} />
      <Route path="/reports/payout-reports" element={<PayoutReports />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default RetailerRoutes;

